import client from "apolloClient"
import getPromoCodes from "gql/promocode/queries/getPromoCodes"

export default ({ pagination, filter }) => async () => {
    try {
        const response = await client.query({
            query: getPromoCodes,
            variables: {
                pagination, filter
            }
        }).then(response => response.data.getPromoCodes.result)

        return response
        
    } catch (error) {
        console.error("Err in getPromoCodes", error)
    }
}